import {
  hasAnyRole,
  TOTVS_INTEGRATOR_WRITE_ROLES,
} from '@/shared/guards/roles';
import { useEffectiveRoles } from '@/shared/view-as/use-effective-roles';

/**
 * `true` se o usuário atual pode EXECUTAR ações no Integrador TOTVS (reprocessar,
 * editar payload, criar/editar/desativar de-para). O `totvsIntegratorViewer`
 * apenas visualiza, então recebe `false`; os dois admins principais e o
 * `totvsIntegratorAdmin` recebem `true`. É só UX — o backend (@Roles no
 * `TotvsAdminController`) é a autoridade real e barra o viewer nas rotas de escrita.
 */
export function useCanWriteTotvs(): boolean {
  const roles = useEffectiveRoles();
  return hasAnyRole(roles, TOTVS_INTEGRATOR_WRITE_ROLES);
}
